export default __webpack_public_path__ + "static/media/icon-analytics-blue.7a771ce4.svg";